import {
  TipoElementoAggiuntivoCollegamentiValue,
  TipologiaElementoExtraTableValue,
} from 'constants/inspections';
import { tipologiaElementoExtraOptions } from 'constants/selectOptions';

// Mappa il "Tipo Elemento" (Muro d'ala/andatore, Paraghiaia, Baggioli, Altro) alla
// chiave della matrice schede difetti in schedeDifetti.js. Condivisa da L0/L1 e
// dal flusso di copia, per non disallineare la logica di gating.
export const SCHEDA_KEY_MAP_ELEMENTI_AGGIUNTIVI_COLLEGAMENTI = {
  [TipoElementoAggiuntivoCollegamentiValue.MuroDAla]: 'muroDAla',
  [TipoElementoAggiuntivoCollegamentiValue.MuroAndatore]: 'muroAndatore',
  [TipoElementoAggiuntivoCollegamentiValue.Paraghiaia]: 'paraghiaia',
  [TipoElementoAggiuntivoCollegamentiValue.Baggioli]: 'baggioli',
  [TipoElementoAggiuntivoCollegamentiValue.Altro]: 'elementoExtra',
};

// Nessuna scheda finché il "Tipo Elemento" non è stato scelto esplicitamente
// (populateSchedaDifetti gestisce già il caso tipologia non valorizzata).
export const getSchedaDifettiElementoAggiuntivoCollegamenti = (
  populateSchedaDifetti,
  tipo,
  tipologia
) => {
  const schedaKey = SCHEDA_KEY_MAP_ELEMENTI_AGGIUNTIVI_COLLEGAMENTI[tipo];
  return schedaKey
    ? populateSchedaDifetti(schedaKey, tipologia)
    : [{ alert: true }];
};

export const getTipologiaOptionsElementoAggiuntivoCollegamenti = tipo => {
  // "Tipo Elemento" non ancora scelto (es. tornato a "Nessun valore") non va
  // confuso con "Altro" (che ammette davvero tutti i materiali): nessuna
  // opzione ammissibile finché non si sceglie un tipo, altrimenti il
  // controllo "tipologia ancora ammissibile" in ElementiAggiuntiviForm.jsx
  // trova sempre un match e non svuota più "Tipologia" al reset del Tipo.
  if (!tipo) return [];
  if (tipo === TipoElementoAggiuntivoCollegamentiValue.Altro) {
    return tipologiaElementoExtraOptions;
  }
  return tipologiaElementoExtraOptions.filter(
    o => o.value === TipologiaElementoExtraTableValue.CalcestruzzoArmato
  );
};
